import { useId, useState } from 'react';
import { kebabCase } from 'lodash';

import { Button, Grid, Text, useTheme } from '@simplywallst/ui-core';
import ChevronRightSmallSolid from '@simplywallst/ui-core/icons/ChevronRightSmallSolid';
import ChevronDownSmallSolid from '@simplywallst/ui-core/icons/ChevronDownSmallSolid';
import { Truncator } from '@/components/Truncator';

type Props = {
  title: string;
  children: React.ReactNode;
};

export const Accordion = ({ title, children }: Props) => {
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const panelId = useId();
  const panelTitleId = useId();

  return (
    <Grid backgroundColor="phantom" borderRadius="x1">
      <Button
        styleType="passive"
        id={panelTitleId}
        onClick={toggleAccordion}
        data-cy-id={`${kebabCase(title)}-accordion`}
        aria-expanded={isOpen ? 'true' : 'false'}
        aria-controls={panelId}
        style={{ height: 'auto', padding: theme.x2 }}
      >
        <Grid templateColumns="auto min-content" alignItems="center">
          <Text typography="xSmall" color="textSofter" textAlign="left">
            {title}
          </Text>

          {isOpen ? (
            <ChevronDownSmallSolid
              height="24"
              width="24"
              fill={theme.color.whiteRGBA(0.3)}
            />
          ) : (
            <ChevronRightSmallSolid
              height="24"
              width="24"
              fill={theme.color.whiteRGBA(0.3)}
            />
          )}
        </Grid>
      </Button>

      <Truncator open={isOpen} minHeight={0} animationDuration={0.3}>
        <div
          id={panelId}
          role="region"
          aria-labelledby={panelTitleId}
          aria-hidden={isOpen ? 'false' : 'true'}
        >
          {children}
        </div>
      </Truncator>
    </Grid>
  );
};
